
export default ({ children }) => children();
